<template>
  <div id="app">
	<keep-alive>
	   <router-view v-if="$route.meta.keepAlive"></router-view>
	</keep-alive>  
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  watch: {
  },
  created() {
    // this.$nextTick(() => {
    //   // 禁止右键
    //   document.oncontextmenu = new Function("event.returnValue=false");
    //   // 禁止F12
    //   document.onkeydown = new Function("event.returnValue=false");
    //   this.all()
    // });
  },
  methods:{
    all(){
        this.menu();
        this.keydown();
    },
    menu(){//禁止右键
        document.oncontextmenu = function () {
            return false; 
        };
    },
    keydown(){//禁止F12
        document.onkeydown = function () {
            if (window.event && window.event.keyCode == 123) {
                event.keyCode = 0;
                event.returnValue = false;
                return false;
            }
        };
    }
  }
}
</script>

<style>
</style>
